<div class="pdf-viewer-dialog">
  <div class="pdf-viewer-header" style="height: 40px;">
    <h2 mat-dialog-title>{{ data.fileName || 'Xem file PDF' }}</h2>
    <button mat-icon-button (click)="close()" aria-label="Đóng">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <mat-dialog-content class="pdf-viewer-content">
    <iframe 
      [src]="pdfUrl" 
      frameborder="0" 
      width="100%" 
      height="100%"
      style="min-height: 90vh;">
    </iframe>
  </mat-dialog-content>
</div>

